import "./Contact.css";
import { ToastContainer } from "react-toastify";
import React, { Fragment, useState } from "react";
import {
  Autocomplete,
  Avatar,
  Card,
  FormControl,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { stringAvatar } from "../../../helpers/stringAvatar";
import LeadForm from "../../../components/LeadForm/LeadForm";

const Contact = ({
  register,
  errors,
  Agents,
  setAgent,
  Leads,
  agentId,
  watch,
  setValue,
  set__agent,
  get__agent,
  get__lead,
  set__lead,
  isStepVisited,
  toggleRefresh,
}) => {
  // Modal Start
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen("add");
  const handleClose = () => {
    toggleRefresh();
    setOpen(false);
  };
  // Modal End

  const selectNewLead = () => {
    set__lead(Leads[0].id);
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-xxl-6 col-xl-6 col-lg-2 col-md-2 col-sm-2"></div>
        {Leads && (
          <div className="col-xxl-6 col-xl-6 col-lg-10 col-md-10 col-sm-10 col-12">
            <a
              href="#"
              className="addNewLead"
              data-toggle="modal"
              data-target=".bd-example-modal-lg"
              onClick={handleOpen}
            >
              Add New Client
            </a>
          </div>
        )}
      </div>

      <input type={"hidden"} {...register("lead")} />
      <label className="custom-field-title">
        Client <span style={{ color: "red" }}>*</span>
      </label>
      <FormControl fullWidth className="whiteBackground" id="custom-select">
        {Leads && (
          <Autocomplete
            id="tags-outlined"
            options={Leads}
            autoHighlight={true}
            Lead
            getOptionLabel={(option) => option.name}
            onChange={(event, value, reason, details) => {
              setValue("lead", value.id);
              set__lead(value.id);
            }}
            value={Leads && Leads.filter(({ id }) => id === get__lead()).pop()}
            renderOption={(props, option) => (
              <MenuItem {...props} id={option.id}>
                {
                  <Card
                    sx={{ display: "flex" }}
                    className="contact-section-clients-dropdown"
                    elevation={0}
                  >
                    <Avatar
                      className="add-property-contact-section-client-avatar"
                      {...stringAvatar(option.name)}
                      // style={{ width: "32px", height: "28px" }}
                    />
                    <Typography
                      component="div"
                      variant="p"
                      className="add-property-contact-section-client-name"
                    >
                      {option.name}
                    </Typography>
                  </Card>
                }
              </MenuItem>
            )}
            renderInput={(params) => {
              return (
                <div>
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Search Client"
                  />
                </div>
              );
            }}
          />
        )}
      </FormControl>

      {/* Agents */}

      <br></br>
      <br></br>
      <label className="custom-field-title">
        Agent <span style={{ color: "red" }}>*</span>
      </label>
      <FormControl
        fullWidth
        className="whiteBackground mt-3"
        id="custom-select"
        style={{
          marginTop: "0 !important",
        }}
      >
        {Agents && (
          <Autocomplete
            id="tags-outlined"
            options={Agents}
            autoHighlight={true}
            Agent
            getOptionLabel={(option) => option.name}
            onChange={(event, value, reason, details) => {
              setValue("agent", value.id);
              set__agent(value);
            }}
            value={get__agent()}
            renderOption={(props, option) => (
              <MenuItem {...props} id={option.id}>
                {
                  <Card
                    sx={{ display: "flex" }}
                    className="contact-section-agents-dropdown"
                    elevation={0}
                  >
                    <Avatar
                      className="add-property-contact-section-agent-avatar"
                      {...stringAvatar(option.name)}
                    />
                    <Typography
                      component="div"
                      variant="p"
                      className="add-property-contact-section-agent-name"
                    >
                      {option.name}
                    </Typography>
                  </Card>
                }
              </MenuItem>
            )}
            renderInput={(params) => {
              return (
                <div>
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Search Agent"
                  />
                </div>
              );
            }}
          />
        )}
      </FormControl>

      <LeadForm
        {...{
          open,
          setOpen,
          SingleLeadData: null,
          setSingleLeadData: () => {},
          LeadId: "",
          handleRefresh: toggleRefresh,
        }}
      />
      <ToastContainer />
    </Fragment>
  );
};

export default Contact;
